import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'h-[42px] w-full rounded-[9px] border border-zinc-300 px-3 text-sm font-[inherit] text-text',
        'placeholder:text-muted focus-visible:border-accent-hover',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
